/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {ModuleWithProviders, NgModule, inject} from '@angular/core';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpTranslateLoader} from './translate-require-loader.service';

/**
 * This module is used to initialize the translation configuration for the application
 * This includes:
 * - Adding the SyncTranslateLoader that imports the JSON files used for the translations
 * This module re-exports the TranslateModule so that it can be used by the AppModule
 * All other modules should continue using the TranslateModule inside their imports as we only set the forRoot() once
 */
@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: HttpTranslateLoader,
      },
    }),
  ],
  exports: [TranslateModule],
})
export class PspTranslateModule {
  constructor() {
    const parentModule = inject(PspTranslateModule, {optional: true, skipSelf: true});

    if (parentModule) {
      throw new Error('PspTranslateModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders<PspTranslateModule> {
    return {
      ngModule: PspTranslateModule,
    };
  }
}
